export enum CouponUsageTypes {
  SingleUse = 1,
  OncePerCustomer,
  Unlimited
}

export enum DoctorTypeEnum {
  Normal = 1,
  Se7etak,
  All
}
